import { AppDispatch } from "../store";
import { setNotification } from "../store/toastNotifications";
import { TransportationType } from "../types/ganttChart";
import api, { API_PATHS } from "./api";

class EmployeeSettingsService {
  static async editEmployeeWorkTime(
    shiftId: number,
    workTimeStart: string,
    workTimeEnd: string,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.updateEmployeeWorkTime, null, {
        params: { shiftId, workTimeStart, workTimeEnd },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async editEmployeeTransportType(
    shiftId: number,
    // transportationType: EmployeeTransport[], // toggle back on multi-transports
    transportationTypeName: TransportationType,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.updateEmployeeTransportType, null, {
        params: { shiftId, transportationTypeName },
      }); // send it as body on multi-transports
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async deleteEmployeeWorkTime(shiftId: number, dispatch: AppDispatch) {
    try {
      await api.post(API_PATHS.deleteEmployeeWorkTime, null, {
        params: { shiftId },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async deleteEmployeeTransportType(
    shiftId: number,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.deleteEmployeeTransportType, null, {
        params: { shiftId },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }
}

export default EmployeeSettingsService;
